import React from "react";
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";

const CITIES = [
  { name: "El Paso", slug: "el-paso", pop: "680K+" },
  { name: "Lubbock", slug: "lubbock", pop: "260K+" },
  { name: "Waco", slug: "waco", pop: "140K+" },
  { name: "Killeen", slug: "killeen", pop: "150K+" },
  { name: "Amarillo", slug: "amarillo", pop: "200K+" },
];

const SERVICES = [
  { name: "SEO", slug: "seo", color: "text-green-400" },
  { name: "Local SEO", slug: "local-seo", color: "text-blue-400" },
  { name: "GBP Optimization", slug: "gbp-optimization", color: "text-yellow-400" },
];

const TexasCoverageWidget = ({ variant = "full" }) => {
  if (variant === "compact") {
    return (
      <div className="bg-white/5 border border-white/10 rounded-xl p-5" data-testid="texas-coverage-compact">
        <div className="flex items-center gap-2 mb-4">
          <MapPin className="w-4 h-4 text-[#2ABFBF]" />
          <h3 className="text-white font-semibold text-sm">We Serve All of Texas</h3>
        </div>
        <div className="space-y-3">
          {CITIES.map(city => (
            <div key={city.slug}>
              <p className="text-gray-500 text-xs uppercase mb-1.5">{city.name}, TX</p>
              <div className="flex flex-wrap gap-1.5">
                {SERVICES.map(svc => (
                  <Link
                    key={svc.slug}
                    to={`/${svc.slug}-${city.slug}`}
                    className={`text-xs px-2.5 py-1 rounded-full border border-white/10 hover:border-[#2ABFBF]/30 hover:bg-[#2ABFBF]/5 transition-colors ${svc.color}`}
                  >
                    {svc.name}
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>
        <Link to="/free-ai-visibility-audit" className="flex items-center gap-1 text-[#2ABFBF] text-xs mt-4 hover:underline">
          Free AI Visibility Audit <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
    );
  }

  return (
    <section className="py-16" data-testid="texas-coverage-section">
      <div className="container-custom max-w-6xl mx-auto px-4">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#2ABFBF]/10 border border-[#2ABFBF]/20 text-[#2ABFBF] text-sm font-medium mb-4">
            <MapPin className="w-4 h-4" /> Statewide Coverage
          </div>
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">Digital Marketing Across Texas</h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            From El Paso to Amarillo — we help Texas businesses dominate local search, Google Maps, and AI-powered search engines.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {CITIES.map(city => (
            <div key={city.slug} className="bg-white/5 border border-white/10 rounded-xl p-5 hover:border-[#2ABFBF]/20 transition-colors" data-testid={`coverage-city-${city.slug}`}>
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-white font-semibold">{city.name}</h3>
                <span className="text-xs text-gray-500">{city.pop}</span>
              </div>
              <div className="space-y-1.5">
                {SERVICES.map(svc => (
                  <Link
                    key={svc.slug}
                    to={`/${svc.slug}-${city.slug}`}
                    className="flex items-center justify-between text-sm text-gray-400 hover:text-[#2ABFBF] transition-colors py-1 group"
                  >
                    <span>{svc.name}</span>
                    <ArrowRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity" />
                  </Link>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <Link to="/free-ai-visibility-audit" className="inline-flex items-center gap-2 text-[#2ABFBF] font-medium hover:underline">
            Get a Free AI Visibility Audit for Your City <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TexasCoverageWidget;
